import { ReactNode } from "react";
import { TranslationKey } from "../../../shared/i18n/i18n";
import { DisabledActionReason, formatDisabledActionTooltip } from "../../utils/adminPermissions";

type AdminActionButtonProps = {
  ariaLabel: string;
  children: ReactNode;
  className: string;
  disabled?: boolean;
  disabledReason?: DisabledActionReason;
  onClick: () => void;
  t: (key: TranslationKey) => string;
  title: string;
  type?: "button" | "submit";
};

export const AdminActionButton = ({
  ariaLabel,
  children,
  className,
  disabled = false,
  disabledReason = null,
  onClick,
  t,
  title,
  type = "button",
}: AdminActionButtonProps) => {
  return (
    <button
      aria-label={ariaLabel}
      className={className}
      disabled={disabled}
      onClick={onClick}
      title={formatDisabledActionTooltip(title, disabledReason, t)}
      type={type}
    >
      {children}
    </button>
  );
};
